/**
 * Use one of these className constants on a scrollable element
 * to apply a modified scrollbar style to it.
 */
export var scrollbarClassNames = {
  slim: "lodestar--global-scrollbars--slim"
};
//# sourceMappingURL=scrollbars.js.map